import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useGetCurrentUserInfoQuery, useGetUserIdQuery, usePostUserChangeStatusMutation } from '../../store/api/userApi'
import { hideApproveDialog } from '../../store/slice/dialogSlice'
import {
  useGetRequestByInfoQuery,
  usePostRequestChangeDetailStatusMutation,
  usePostRequestChangeMainStatusMutation,
} from '../../store/api/requestApi'
import { MultilineTextBox } from '../TextBox'
import { useGetVendorCardQuery, usePostVendorChangeStatusMutation } from '../../store/api/vendorApi'
import { offRefreshButton, onRefreshButton } from '../../store/slice/buttonSlice'
import { showErrorToast, showSuccessToast } from '../../constToast/constToast'
import { usePostOrderChangeStatusMutation } from '../../store/api/orderApi'
import { usePostPaymentChangeStatusMutation } from '../../store/api/paymentApi'
import { head } from 'lodash'
import { usePostChangeInvoiceStatusMutation } from '../../store/api/invoiceApi'
import { updateRefetchData } from '../../store/slice/otherSlice'
import { updateSelectedMaterialData } from '../../store/slice/persistSlice'
import { updateUserData, updateVendorData } from '../../store/slice/mainToCardSlice'

const ApproveDialog = ({ data, callback }) => {
  const dispatch = useDispatch()
  const handleClose = () => {
    dispatch(hideApproveDialog())
    setComment('')
  }
  const open = useSelector((state) => state.dialogSlice.approveDialog)
  const url = useLocation().pathname
  const [comment, setComment] = useState('')

  const userData = useSelector((state) => state.mainToCard.userData)
  const requestDataSlice = useSelector((state) => state.persistSlice.requestData)
  const vendorData = useSelector((state) => state.mainToCard.vendorData)
  const orderData = useSelector((state) => state.mainToCard.orderData)
  const invoiceMain = useSelector((state) => state.mainToCard.invoiceMain)
  const selectedMaterialData = useSelector((state) => state.persistSlice.selectedMaterialData)
  const requestDetailsData =
    selectedMaterialData &&
    selectedMaterialData?.map((item) => ({ requestDetailId: item?.requestDetailId, sequence: item?.sequence }))
  const materialTableDataSlice = useSelector((state) => state.persistSlice.materialData)

  useEffect(() => {
    dispatch(
      updateSelectedMaterialData([
        materialTableDataSlice?.find((item) => item?.lineNo == selectedMaterialData?.map((item) => item?.lineNo)),
      ])
    )
  }, [materialTableDataSlice])

  const orderPersistData = useSelector((state) => state.persistSlice.orderPersistData)
  const paymentDataSlice = useSelector((state) => state.persistSlice.paymentData)
  const paymentCardDataSlice = useSelector((state) => state.paymentSlice.paymentCardDataSlice)
  const paymentCardDataSliceHeader = paymentCardDataSlice?.header
  const buData = useSelector((state) => state.persistSlice.buData)
  const { data: currentUserData } = useGetCurrentUserInfoQuery()

  const [addUserStatus] = usePostUserChangeStatusMutation()
  const [postChangeMainStatus, { isLoading: postChangeMainStatusLoading }] = usePostRequestChangeMainStatusMutation()
  const [postChangeDetailStatus, { isLoading: postChangeDetailStatusLoading }] =
    usePostRequestChangeDetailStatusMutation()
  const [postVendorChangeStatus] = usePostVendorChangeStatusMutation()
  const [postOrderChangeStatus] = usePostOrderChangeStatusMutation()
  const [postChangePaymentStatus] = usePostPaymentChangeStatusMutation()
  const [postChangeInvoiceStatus] = usePostChangeInvoiceStatusMutation()

  let content, action, name

  const handleRefresh = () => {
    dispatch(onRefreshButton())
    setTimeout(() => {
      dispatch(offRefreshButton(false))
    }, 1)
  }

  const navigate = useNavigate()

  const { dataId } = useParams()
  const { data: userInfo } = useGetUserIdQuery(dataId)
  const { data: vendorInfo } = useGetVendorCardQuery(dataId)
  const { data: requestData } = useGetRequestByInfoQuery({
    requestMainId: dataId,
    businessUnitId: buData != null ? buData : currentUserData?.data?.defaultBusinessUnitId,
  })

  const invoiceBuData = useSelector((state) => state.invoiceSlice.invoiceBuData)

  const handlePostVendorChange = async () => {
    const data = await postVendorChangeStatus({
      vendorId: vendorData[0]?.vendorId,
      approveStatusId: 1,
      sequence: vendorData[0]?.sequence,
      comment: comment,
    })
    if (data?.data?.data) {
      showSuccessToast(`Succesfully`)
    } else {
      showErrorToast('Error')
    }
    setComment('')
    handleClose()
    handleRefresh()

    dispatch(updateVendorData([]));
  }

  switch (url) {
    // USERS
    case '/users':
      name = <>{userData[0]?.userName}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button
          variant="contained"
          onClick={() => {
            addUserStatus([
              {
                id: userData[0]?.id,
                sequence: userData[0]?.sequence,
                approveStatus: 1,
                comment,
              },
            ])
            setComment('')
            dispatch(updateUserData([]));
            handleClose()
            showSuccessToast('Success')
          }}
        >
          Approve
        </Button>
      )
      break
    case `/users/${userInfo?.data?.id}`:
      name = <>{userInfo?.data?.userName}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button
          variant="contained"
          onClick={() => {
            addUserStatus([
              {
                id: userInfo?.data?.id,
                approveStatus: 1,
                comment,
                sequence: Number(localStorage.getItem('userSequence')),
              },
            ])
            navigate('/users')
            setComment('')
            handleClose()
            showSuccessToast('Success')
          }}
        >
          Approve
        </Button>
      )
      break

    // Request
    case '/requests':
      name = <>{requestDataSlice && requestDataSlice?.map((item) => item.requestNo).join(', ')}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button
          variant="contained"
          disabled={postChangeMainStatusLoading}
          isLoading={postChangeMainStatusLoading}
          onClick={async () => {
            const requestDataArray = requestDataSlice?.map((item) => ({
              requestMainId: item.requestMainId,
              requestNo: item.requestNo,
              sequence: item.sequence,
            }))

            const data = await postChangeMainStatus({
              requestDatas: requestDataArray,
              approveStatus: 1,
              comment,
              businessUnitName: requestDataSlice?.[0].businessUnitName,
            })

            if (data?.data?.statusCode === 200) {
              showSuccessToast('Succesfully')
            }

            handleRefresh()
            setComment('')
            handleClose()
          }}
        >
          Approve
        </Button>
      )
      break

    // Payment
    case '/payment':
      name = <>{paymentDataSlice && paymentDataSlice?.map((item) => item.paymentRequestNo).join(', ')}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button
          variant="contained"
          onClick={async () => {
            const paymentDataArray = {
              payments: paymentDataSlice?.map((item) => ({
                paymentDocumentMainId: item.paymentDocumentMainId,
                sequence: item.sequence,
              })),
              approveStatus: 1,
              comment,
            }

            const data = await postChangePaymentStatus(paymentDataArray)

            if (data?.data?.statusCode === 200) {
              showSuccessToast('Succesfully')
            }

            handleRefresh()
            setComment('')
            handleClose()
          }}
        >
          Approve
        </Button>
      )
      break


    // Request Detail
    case `/requests/${requestData?.data?.requestMainId}`:
      name = <>Line No {selectedMaterialData && selectedMaterialData.map((item) => item?.lineNo).join(', ')}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button
          variant="contained"
          disabled={postChangeDetailStatusLoading}
          onClick={async () => {
            const data = await postChangeDetailStatus({
              requestDetails: requestDetailsData,
              approveStatus: 1,
              comment,
              businessUnitName: requestData?.data?.businessUnitName,
            })
            if (data?.data?.statusCode === 200) {
              showSuccessToast('Succesfully')
            }
            handleRefresh()
            setComment('')
            handleClose()
          }}
        >
          Approve
        </Button>
      )
      break

    // Vendors
    case '/vendors':
      name = <>{vendorData[0]?.vendorName}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button variant="contained" onClick={handlePostVendorChange}>
          Approve
        </Button>
      )
      break

    // Vendors   //  rfqmaindid ve ya vendorid ye gore de if qoyulacaq
    case `/vendors/${vendorInfo?.data?.header?.vendorId}`:
      name = <>{vendorInfo?.data?.header?.vendorName}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button
          variant="contained"
          onClick={() => {
            postVendorChangeStatus({
              vendorId: vendorInfo?.data?.header?.vendorId,
              approveStatusId: 1,
              sequence: vendorInfo?.data?.header?.sequence,
              comment: comment,
            })
            setComment('')
            handleClose()
            handleRefresh()

            showSuccessToast('Succesfully')
          }}
        >
          Approve
        </Button>
      )
      break

    // Orders
    case '/orders':
      name = <>{orderData[0]?.orderNo}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button
          variant="contained"
          onClick={() => {
            postOrderChangeStatus({
              orderMainId: orderData[0]?.orderMainId,
              approveStatusId: 1,
              sequence: orderData[0]?.sequence,
              comment: comment,
              rejectReasonId: null,
            })
            handleRefresh();
            setComment('')
            handleClose()
            dispatch(updateRefetchData())
            showSuccessToast('Succesfully')
          }}
        >
          Approve
        </Button>
      )
      break

    case `/orders/${dataId}`:
      name = <>{orderPersistData?.[0]?.orderNo}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button
          variant="contained"
          onClick={() => {
            postOrderChangeStatus({
              orderMainId: orderPersistData?.[0]?.orderMainId,
              approveStatusId: 1,
              sequence: orderPersistData?.[0]?.sequence,
              comment: comment,
              rejectReasonId: null,
            })

            setComment('')
            handleClose()
            dispatch(updateRefetchData())
            showSuccessToast('Succesfully')
            navigate('/orders')
          }}
        >
          Approve
        </Button>
      )
      break

    case '/invoice-register':
      name = <>{invoiceMain[0] && invoiceMain?.map(x => x.invoiceNo).join(', ')}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button
          variant="contained"
          onClick={async () => {
            const res = await postChangeInvoiceStatus({
              invoiceRegisterIds: invoiceMain?.map((item) => {
                return {
                  invoiceRegisterId: item?.invoiceRegisterId,
                  sequence: item?.sequence,
                  inMaxSequence: item?.inMaxSequence,
                  invoiceTypeId: item?.invoiceType,
                }
              }),
              approveStatus: 1,
              comment,
              businessUnitId: invoiceBuData
            })
            setComment('')
            handleClose()
            handleRefresh()
            if (res?.data?.statusCode === 200) {
              showSuccessToast(`${invoiceMain[0] && invoiceMain?.map(x => x.invoiceNo).join(', ')} approved`)
            } else {
              showErrorToast('Error')
            }
          }}
        >
          Approve
        </Button>
      )
      break
    default:
      content = null
      break
  }

  return (
    <div>
      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle>Approve {name}</DialogTitle>
        <Divider />
        <DialogContent>{content}</DialogContent>
        <DialogActions>
          {action}
          <Button variant="outlined" onClick={handleClose} sx={{ color: 'gray', borderColor: '#D3D3D3' }}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default ApproveDialog